// extracted by mini-css-extract-plugin
export default {"row":"CloudFolderRow_row__fZ6H2","text":"CloudFolderRow_text__LKMCY"};